// @ts-nocheck
import React, { useCallback, useState } from 'react';
import { FormattedMessage as T } from '@/components';
import { ListSelect } from '@/components';
import { Menu, MenuItem } from '@blueprintjs/core';
import { saveInvoke } from '@/utils';
import classNames from 'classnames';
import { CLASSES } from '@/constants/classes';

export function CategoriesSelectList({
  categories,
  selecetedCategoryId,
  defaultSelectText = <span style={{ color: '#8c8c8c' }}><T id={'select_category'} /></span>,
  onCategorySelected,
  onQuickAdd,
  popoverFill = false,
  className,
  ...restProps
}) {
  const [isOpen, setIsOpen] = useState(false);

  // Filter Items Category
  const filterItemCategory = (query, item, _index, exactMatch) => {
    const normalizedTitle = item.name.toLowerCase();
    const normalizedQuery = query.toLowerCase();
    if (exactMatch) {
      return normalizedTitle === normalizedQuery;
    } else {
      return `${item.code} ${normalizedTitle}`.indexOf(normalizedQuery) >= 0;
    }
  };

  const handleItemCategorySelected = useCallback(
    (ItemCategory) => saveInvoke(onCategorySelected, ItemCategory),
    [onCategorySelected],
  );

  const categoryItem = useCallback(
    (item, { handleClick }) => (
      <MenuItem key={item.id} text={item.name} onClick={handleClick} />
    ),
    [],
  );

  const handleInteraction = useCallback((nextOpen) => {
    setIsOpen(nextOpen);
  }, []);

  const handleQuickAddClick = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      setIsOpen(false);
      onQuickAdd && onQuickAdd();
    },
    [onQuickAdd],
  );

  const itemListRenderer = useCallback(
    ({ filteredItems, itemsParentRef, renderItem }) => (
      <Menu ulRef={itemsParentRef}>
        {filteredItems.map((item, index) => renderItem(item, index))}
        {onQuickAdd && (
          <>
            <li style={{ borderTop: '1px solid #E0E0E0', margin: '4px 0' }} />
            <MenuItem
              key="quick-add"
              text={<span style={{ color: '#1890FF', fontWeight: 500 }}>+ Quick Add</span>}
              onClick={handleQuickAddClick}
            />
          </>
        )}
      </Menu>
    ),
    [handleQuickAddClick, onQuickAdd],
  );
  return (
    <ListSelect
      items={categories}
      selectedItemProp={'id'}
      selectedItem={selecetedCategoryId}
      textProp={'name'}
      defaultText={defaultSelectText}
      onItemSelect={handleItemCategorySelected}
      itemPredicate={filterItemCategory}
      itemListRenderer={itemListRenderer}
      itemRenderer={categoryItem}
      isOpen={isOpen}
      onInteraction={handleInteraction}
      popoverProps={{ minimal: true, usePortal: !popoverFill }}
      className={classNames(
        'form-group--select-list',
        {
          [CLASSES.SELECT_LIST_FILL_POPOVER]: popoverFill,
        },
        className,
      )}
      {...restProps}
    />
  );
}
